import React from "react";
import { Spinner } from "react-bootstrap";
import "./styles.css";
const ModalSpinner = (props) => {
  return (
    <div className="modalContainer">
      <Spinner animation="border" variant="primary" />
    </div>
  );
};

export default ModalSpinner;
